<script lang="ts">
	import { page } from '$app/stores';
	import { lazyLoad } from '$lib/actions/lazyLoad';
	import Facebook from '$lib/assets/images/icons/facebook.svg?component';
	import Instagram from '$lib/assets/images/icons/instagram.svg?component';
	import Linkedin from '$lib/assets/images/icons/linkedin.svg?component';
	import Tiktok from '$lib/assets/images/icons/tiktok.svg?component';
	import WhatsApp from '$lib/assets/images/icons/whatsapp.svg?component';
	import Youtube from '$lib/assets/images/icons/youtube.svg?component';
	import pda2025Footer from '$lib/assets/images/pda_2025_footer.svg';
	import domain from '$lib/stores/DomainStore';
	import __ from '$lib/stores/TranslationStore';

	export let compact: bool = false;
	export let classInt: string = '';
</script>

<div class="relative z-10 bg-dark" data-sveltekit-preload-data="off">
	<footer class="container mx-auto lg:px-0 {classInt}">
		{#if !compact}
			<div class="grid grid-cols-1 gap-8 py-16 font-light md:grid-cols-4 lg:gap-0 lg:px-6 lg:py-20">
				<div>
					<ul class="text-light">
						<li class="mb-4">
							<a href="{$page.data?.location?.origin}/credito-habitacao" class=" hover:underline"
								>{$__('Crédito habitação')}</a
							>
						</li>
						{#if !$page.data.int_ch}
							<li class="mb-4">
								<a href="{$page.data?.location?.origin}/credito-pessoal" class="hover:underline"
									>{$__('Crédito pessoal')}</a
								>
							</li>
							<li class="mb-4">
								<a href="{$page.data?.location?.origin}/seguros" class="hover:underline"
									>{$__('Seguros')}</a
								>
							</li>
							<li class="mb-4">
								<a href="{$page.data?.location?.origin}/artigos" class="hover:underline"
									>{$__('Artigos')}</a
								>
							</li>
						{/if}
					</ul>
				</div>
				<div>
					<ul class="text-light">
						<li class="mb-4">
							<a href="{$page.data?.location?.origin}/sobre" class="hover:underline"
								>{$__('Sobre nós')}</a
							>
						</li>
						<li class="mb-4">
							<a href="{$page.data?.location?.origin}/recrutamento" class="hover:underline"
								>{$__('Recrutamento')}</a
							>
						</li>
						<li class="mb-4">
							<a href="{$page.data?.location?.origin}/contacto" class="hover:underline"
								>{$__('Contacto')}</a
							>
						</li>
					</ul>
				</div>
				<div>
					<ul class="text-light">
						<li class="mb-4">
							<a href="{$page.data?.location?.origin}/termos-e-condicoes" class="hover:underline"
								>{$__('Termos e condições')}</a
							>
						</li>
						<li class="mb-4">
							<a
								href="{$page.data?.location?.origin}/politica-de-protecao-de-dados"
								class="hover:underline">{$__('Política de proteção de dados')}</a
							>
						</li>
						<li class="mb-4">
							<a
								href="{$page.data?.location?.origin}/intermediario-de-credito"
								class="hover:underline">{$__('Intermediário de Crédito nº 0006860')}</a
							>
						</li>
						<li class="mb-4">
							<a
								target="_blank"
								rel="noreferrer"
								href="https://www.livroreclamacoes.pt/Inicio/"
								class="hover:underline">{$__('Livro de reclamações Online')}</a
							>
						</li>
						<li class="mb-4">
							<a href="{$page.data?.location?.origin}/centros-de-arbitragem" class="hover:underline"
								>{$__('Centros de arbitragem')}</a
							>
						</li>
					</ul>
				</div>
				<div class="order-first lg:order-last">
					<div class="flex gap-3 font-semibold text-white lg:justify-end">
						{#each ['PT', 'EN', 'FR'] as lang}
							<form method="POST" action="/translate">
								<input type="hidden" name="language" value={lang.toLowerCase()} />
								<input type="hidden" name="origin" value={$page?.url?.pathname} />
								<button
									class="{$page.data.language == lang.toLowerCase()
										? 'bg-primary-light text-dark'
										: ''} block h-8 w-8 rounded-full text-center leading-8">{lang}</button
								>
							</form>
						{/each}
					</div>
					<div class="flex gap-3 lg:justify-end">
						<a
							href={'/artigos/institucional/vai-contratar-credito-conheca-o-intermediario-eleito-produto-do-ano-2025'}
						>
							<img
								use:lazyLoad={pda2025Footer}
								alt="Eleito Produto do Ano 2025"
								class="h-[130px]] mt-[50px] hidden w-[92px] justify-end object-contain md:block"
								loading="lazy"
							/>
						</a>
					</div>
				</div>
			</div>
		{/if}
		<div class="block flex flex-col items-end gap-14 pb-14 align-top md:flex-row md:px-4">
			<div class="order-2 block flex justify-start md:hidden">
				<div class="mr-[30px]">
					<a
						href={'/artigos/institucional/vai-contratar-credito-conheca-o-intermediario-eleito-produto-do-ano-2025'}
					>
						<img
							use:lazyLoad={pda2025Footer}
							alt="Eleito Produto do Ano 2025"
							class="mr-[30px] inline h-[159px] w-[300px] object-contain"
							loading="lazy"
						/>
					</a>
				</div>
				<div>
					<img
						class=" height-[69px] inline w-[144px] align-top md:aspect-[2/1]"
						use:lazyLoad={$domain?.logoFooter}
						alt="Poupança no minuto"
					/>
					<div class="mt-[30px] text-[10px] text-xs text-white">
						<p class="leading-5">
							{$__(
								'Financefy S.A. Intermediário de Crédito registo no Banco de Portugal com o nº 0006860'
							)}
						</p>
						<p class="leading-5">
							{$__('Financefy - Mediação de Seguros Lda, inscrita na ASF com o nº 423578365')}
						</p>
					</div>
				</div>
			</div>
			<div
				class="order-last mr-60 hidden basis-1/6 self-center md:order-first md:block md:basis-auto"
			>
				<img
					width="144px"
					height="69px"
					class="hidden aspect-[2/1] md:block"
					use:lazyLoad={$domain?.logoFooter}
					alt="Poupança no minuto"
				/>
				<img
					height="35px"
					width="280px"
					class="h-[35px] w-[280px] md:hidden"
					use:lazyLoad={$domain?.logoFooterMobile}
					alt="Poupança no minuto"
				/>
			</div>
			<div
				class="flex hidden basis-2/3 justify-center text-xs font-light text-white md:block md:grow md:basis-auto"
			>
				<div>
					<p class="leading-6">
						{$__(
							'Financefy S.A. Intermediário de Crédito registo no Banco de Portugal com o nº 0006860'
						)}
					</p>
					<p class="leading-6">
						{$__('Financefy - Mediação de Seguros Lda, inscrita na ASF com o nº 423578365')}
					</p>
				</div>
			</div>
			<div
				class="order-1 flex w-full justify-between gap-6 self-center px-0 sm:px-20 md:order-last md:w-auto md:gap-12 md:px-0"
			>
				{#if $domain?.footerLinks.instagram}
					<a href={$domain?.footerLinks.instagram} target="blank" aria-label="Instagram">
						<Instagram class="h-7 fill-white" />
					</a>
				{/if}
				<a href={$domain?.footerLinks.facebook} target="blank" aria-label="Facebook">
					<Facebook class="h-7 w-7 fill-white" />
				</a>
				<a href={$domain?.footerLinks.linkedin} target="blank" aria-label="Linkedin">
					<Linkedin class="h-7 fill-white" />
				</a>
				{#if $domain?.footerLinks.whatsapp}
					<a href={$domain?.footerLinks.whatsapp} target="blank" aria-label="WhatsApp">
						<WhatsApp class="h-7 fill-white" />
					</a>
				{/if}
				{#if $domain?.footerLinks.youtube}
					<a href={$domain?.footerLinks.youtube} target="blank" aria-label="Youtube">
						<Youtube class="h-7 fill-white" />
					</a>
				{/if}
				{#if $domain?.footerLinks.tiktok}
					<a href={$domain?.footerLinks.tiktok} target="blank" aria-label="Youtube">
						<Tiktok class="h-7 fill-white" />
					</a>
				{/if}
			</div>
		</div>

		<hr />
		<div class="block flex flex-col items-end gap-14 pb-14 align-top md:flex-row">
			<div class="order-2 mb-10 mt-10 block flex justify-between text-white">
				<p class="leading-5">
					{$__(
						'Poupança no Minuto é uma marca detida por Financefy, S.A., Intermediário de crédito vinculado registado junto do Banco de Portugal com o n.º 0006860. Serviços autorizados a prestar: Apresentação ou proposta de contratos de crédito a consumidores. Assistência a consumidores, mediante a realização de atos preparatórios ou de outros trabalhos de gestão pré-contratual relativamente a contratos de crédito que não tenham sido por si apresentados ou propostos. Mutuantes: Bankinter, S.A. - Sucursal Em Portugal, Caixa Geral De Depósitos, S.A., Banco BPIi S.A., Banco Santander Totta, S.A., Abanca Corporación Bancaria, S.A., Sucursal Em Portugal, Banco Ctt, S.A., Novo Banco, S.A., Cofidis, BNP Paribas Personal Finance, S.A. - Sucursal Em Portugal, Union De Créditos Inmobiliários, S.A., Establecimiento Financiero De Crédito (Sociedad Unipersonal) - Sucursal Em Portugal, Bni - Banco De Negócios Internacional (Europa), S.A., Banco Bic Português, Sa, Unicre - Instituição Financeira De Crédito, S.A.'
					)}
				</p>
			</div>
		</div>
	</footer>
</div>
